




























import { Component, Vue } from "vue-property-decorator";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import EligibleGiftCards from "@/views/gift-cards/partials/EligibleGiftCards.vue";
import IssuedGiftCards from "@/views/gift-cards/partials/IssuedGiftCards.vue";

@Component({
  name: "Index",
  components: { ApplicationLayout, EligibleGiftCards, IssuedGiftCards }
})
export default class Index extends Vue {
  // ===== Data ===== //
  public loading = false;

  // ===== Lifecycle Hooks ===== //
  private async created() {
    this.loading = true;
    await this.$store.dispatch("getEligibleCards");
    await this.$store.dispatch("getIssuedCards");
    this.loading = false;
  };
};
